module.exports = __webpack_public_path__ + "img/Weapon_03.b5d39587.png";